import { LineLayerSpecification, SymbolLayerSpecification } from 'mapbox-gl';
import { RealtimeLayerIds } from 'src/@realtime/constants';

export const flightLayerStyle: SymbolLayerSpecification = {
  id: RealtimeLayerIds.flightLayer,
  source: RealtimeLayerIds.flightLayer,
  type: 'symbol',
  layout: {
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-size': 0.5,
    'icon-image': ['concat', ['get', 'operationIconKey'], '-', ['get', 'iconKey']],
    'icon-rotate': ['get', 'heading'],
  },
};

export const shadowLayerStyle: SymbolLayerSpecification = {
  id: RealtimeLayerIds.flightShadowLayer,
  source: RealtimeLayerIds.flightLayer,
  type: 'symbol',
  layout: {
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-offset': ['get', 'shadowOffset'],
    'icon-size': 0.5,
    'icon-image': ['concat', 'shadow-', ['get', 'iconKey']],
    'icon-rotate': ['get', 'heading'],
  },
  paint: {
    'icon-opacity': 0.3,
  },
};

const LINE_WIDTH = 2;

// Base layout and type, fully defined
const baseLineLayer: Pick<LineLayerSpecification, 'type' | 'layout'> = {
  type: 'line',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
};

export const tailLayerStyle: LineLayerSpecification = {
  ...baseLineLayer,
  id: RealtimeLayerIds.tailLayer,
  source: RealtimeLayerIds.tailLayer,
  paint: {
    'line-color': ['get', 'operationColor'],
    'line-width': LINE_WIDTH,
    'line-dasharray': [
      'case',
      ['boolean', ['get', 'isSelected'], false],
      ['literal', []], // Solid line if isSelected is true
      ['literal', [1, 2]], // Dashed line otherwise
    ],
  },
};

export const hiddenTailLayerStyle: LineLayerSpecification = {
  ...baseLineLayer,
  id: RealtimeLayerIds.hiddenTailLayer,
  source: RealtimeLayerIds.tailLayer,
  paint: {
    'line-color': 'white',
    'line-width': LINE_WIDTH * 3,
    'line-opacity': 0,
  },
};
